import {Authenticated} from './middleware'

export default [
  {
    name: 'complexExercises',
    path: '/',
    redirect: {name: 'complexExercises.list'},
    component: () => import ('../../views/cpanel/complexExercises'),
    meta: {
      title: 'Комплексы упражнений',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      {
        name: 'complexExercises.list',
        path: 'list',
        component: () => import ('../../views/cpanel/complexExercises/List'),
        meta: {
          title: 'Комплексы упражнений',
          back: 'cpanel.dashboard',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      },
      {
        name: 'complexExercises.item',
        path: ':id?',
        component: () => import ('../../views/cpanel/complexExercises/Item'),
        meta: {
          title: 'Упражнения',
          back: 'complexExercises.list',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      }
    ]
  }

];

